import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { IRentalDetailInitData } from "../../../Models/Rental/Details/RentalDetailInitData";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import { RentDetailsProdSelectTimings } from "./Components/RentDetailsProdSelectTimings";
import { I18nHelper, Translations } from "../../../Lib/Helper/I18nHelper";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { LocalizationModule } from "../../Global/LocalizationModule";
import { PriceHelper } from "../../../Lib/Helper/PriceHelper";
import { RentalDetailLightbox } from "../Components/RentalDetailLightbox";
import { RentDetailsProdSelectCompManager } from "./Services/RentDetailsProdSelectCompManager";

@ModuleName("RentalProductDetails")
export class RentalProductDetails implements AxInit {

    private loadingSpinner: AxLoading;
    private i18nHelper: I18nHelper;

    private rentDetailsProdSelectTimings: RentDetailsProdSelectTimings;
    private rentDetailsProdSelectCompManager: RentDetailsProdSelectCompManager;
    private priceHelper: PriceHelper;

    proceedBtn: HTMLButtonElement;

    AxInit(init: IRentalDetailInitData): void {
        this.i18nHelper = new I18nHelper();
        this.loadingSpinner = new AxLoading();
        this.initComponents(init);

        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        const detailLightbox = new RentalDetailLightbox();
        detailLightbox.init(init.assets);

        this.priceHelper = new PriceHelper(localizationModule.getCultureInfo(), true);
    }

    private initComponents(init: IRentalDetailInitData) {
        this.rentDetailsProdSelectCompManager = new RentDetailsProdSelectCompManager(init.rentalSelectionItem);
        this.rentDetailsProdSelectTimings = new RentDetailsProdSelectTimings(init, this.rentDetailsProdSelectCompManager);

        this.initProceedButton();
    }

    private initProceedButton() {
        this.proceedBtn = document.getElementById('rental_detail__button-proceed') as HTMLButtonElement;
        this.proceedBtn.addEventListener("click", e => {
            this.rentDetailsProdSelectCompManager
                .getProdSelectionComponent()
                .proceed();
        });
    }

    refreshProceedBtn() {
        const locationIsSet = this.rentDetailsProdSelectCompManager
            .locationIsSet();

        const timingsSet = this.rentDetailsProdSelectTimings
            .getSelectedTimings()
            .allBookingTimeParametersAreSet();

        const quantityOk = this.rentDetailsProdSelectCompManager.quantityOk();

        if (locationIsSet && timingsSet && quantityOk) {
            this.proceedBtn.disabled = false;
        } else {
            this.proceedBtn.disabled = true;
        }

        this.setProceedBtnText();
    }

    showLoadingSpinnerOnProceedBtn() {
        this.loadingSpinner.ShowLoadingIndicatorButtonPrimary(this.proceedBtn);
    }

    hideLoadingSpinnerOnProceedBtn() {
        this.loadingSpinner.HideLoadingIndicator(this.proceedBtn);
    }

    private setProceedBtnText() {
        const totalPrice = this.rentDetailsProdSelectCompManager
            .getProdSelectionComponent()
            .getSelectionTotalPrice();

        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');

        const totalProductCount = this.rentDetailsProdSelectCompManager
            .getProdSelectionComponent()
            .getAllProductsCount();

        const bntText = `<p style="margin-bottom: 0;">${totalProductCount} ${this.i18nHelper.GetTranslation(Translations.Rentals)},
            ${this.priceHelper.GetPriceStringWithCurrencySymbol(totalPrice / localizationModule.getPriceToDecimalDivisor())}</p>`;

        this.proceedBtn.innerHTML = bntText;
    }
}